class CartBundle extends HTMLElement {
  constructor() {
    super();

    this.boxVariantId = this.dataset.variantId;
    this.discount = this.dataset.discount;
    this.formId = this.dataset.form;
    this.maxQuantity = Number(this.dataset.max);
    this.textNotification = this.dataset.notification;
    this.maxAmountPerItems = this.dataset.maximumAmount;
    this.currentQuantity = 0;

    this.fieldsets = this.querySelectorAll('.cart-bundle__list');
    this.cartLineProperties = this.querySelector('#cart-line-properties');
    this.quantityBoxes = this.querySelectorAll('.bundle-box');
    this.boxesQuantity = this.querySelectorAll('.bundle-box__quantity');
    this.boxesQuantityInput = this.querySelectorAll('.bundle-box__quantity input');
    this.boxesQuantityButton = this.querySelectorAll('.bundle-box__quantity button');
    this.sizeNotification = document.querySelector('.size-notification');
    this.elements = document.querySelector(`#${this.formId}`)?.elements || [];
    this.elementsProperties = [...this.elements].filter((element) => element.name?.includes('properties'));

    this.priceSelectors = {
      // btn: document.querySelector('.product-info .button-product-price'),
      btn: null,
      price: document.querySelector('.product-info .price-dynamic__money'),
    };
  }

  get quantity() {
    return this.currentQuantity;
  }

  set quantity(value) {
    this.currentQuantity = value;
    this.toggleInactiveBoxes(this.isMaxQuantityReached());
    this.updateLineProperties();
    this.toggleProductFormDisabled(this.quantity < this.maxQuantity);
  }

  connectedCallback() {
    this.attachProperties();
    this.quantityBoxes.forEach((box) => box.addEventListener('click', () => this.toggleBox(box)));

    this.boxesQuantity.forEach((box) => box.addEventListener('click', (event) => event.stopPropagation()));

    this.boxesQuantityButton.forEach((button) =>
      button.addEventListener('click', (event) => this.changeBoxQuantity(event))
    );

    this.elementsProperties.forEach((element) => {
      if (element instanceof HTMLInputElement) {
        element.addEventListener('change', () => {
          this.updateLineProperties();
        });
      }
    });

    this.toggleProductFormDisabled(true);

    if (this.sizeNotification) {
      this.sizeNotification.textContent = this.textNotification;
    }

    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        document.querySelectorAll('.bundle-box__quantity input').forEach((input) => (input.value = 0));
        document.querySelectorAll('.bundle-box').forEach((box) => box.classList.remove('bundle-box--active'));
        this.init();
      }, 2000);
    });
  }

  toggleBox(box) {
    const isActive = box.classList.contains('bundle-box--active');
    const input = box.querySelector('.bundle-box__quantity input');
    const inventory = Number(input.dataset.inventory || Infinity);

    if (!isActive && inventory <= 0) return;

    const newQuantity = isActive ? 0 : 1;

    this.updateInputValue(input, newQuantity);
    box.classList.toggle('bundle-box--active', !isActive);

    this.quantity = this.calculateTotalQuantity();
    this.updateButtonsState();
    this.calculateTotalPrice();
    this.shouldDisabledFieldset(box);
  }

  changeBoxQuantity(event) {
    event.stopPropagation();
    const { name } = event.target;
    const box = event.target.closest('.bundle-box');
    const input = box.querySelector('.bundle-box__quantity input');
    const inventory = Number(input.dataset.inventory || Infinity);

    if (name === 'plus') {
      const currentValue = Number(input.value);
      const remainingGlobal = this.maxQuantity - this.quantity;

      if (this.isMaxQuantityReached()) return;
      if (currentValue >= inventory) return;
      if (remainingGlobal <= 0) return;

      input.stepUp();
      box.classList.add('bundle-box--active');
    }

    if (name === 'minus') {
      input.stepDown();
      if (input.value == 0) {
        box.classList.remove('bundle-box--active');
      }
    }

    this.quantity = this.calculateTotalQuantity();
    this.updateButtonsState();
    this.calculateTotalPrice();
    this.shouldDisabledFieldset(box);
  }

  updateInputValue(input, value) {
    if (input) input.value = value;
  }

  updateLineProperties() {
    const time = Date.now().toString();

    const createHiddenInput = ({ id, amount }, formId, index) => {
      const createInput = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.setAttribute('form', formId);
        input.value = value;
        return input;
      };

      const fieldset = document.createElement('fieldset');
      const base = `items[${index + 1}]`;

      fieldset.append(
        createInput(`${base}[id]`, id),
        createInput(`${base}[quantity]`, amount),
        createInput(`${base}[properties][_bundleId]`, time),
        createInput(`${base}[properties][_maidId]`, this.boxVariantId),
        createInput(`${base}[properties][_discount]`, this.discount)
      );

      const allProperties = [];
      this.elementsProperties.forEach(({ name, value }) => {
        const normalizeField = name.match(/properties\[(.*?)\]/);
        if (normalizeField[1] && value) {
          allProperties.push(`${normalizeField[1]}&&${value}`);
        }
      });

      if (allProperties.length) {
        fieldset.append(createInput(`${base}[properties][_pin]`, allProperties.join('&&&')));
      }

      return fieldset;
    };

    const properties = [...this.boxesQuantityInput]
      .filter((input) => Number(input.value) !== 0)
      .map((input) => ({
        id: input.dataset.id,
        amount: input.value,
      }));

    this.cartLineProperties.replaceChildren(
      ...properties.map((obj, index) => createHiddenInput(obj, this.formId, index))
    );
  }

  toggleInactiveBoxes(disabled) {
    this.getInactiveBoxes().forEach((box) => box.classList.toggle('bundle-box--disabled', disabled));
  }

  toggleProductFormDisabled(isDisabled) {
    const productForms = document.querySelectorAll('buy-buttons');
    productForms.forEach((form) => form.classList.toggle('form-disabled', isDisabled));

    this.toggleNotification(isDisabled);
  }

  toggleNotification(show) {
    this.sizeNotification?.classList.toggle('size-notification--show', show);
  }

  updateButtonsState() {
    this.boxesQuantityInput.forEach((input) => {
      const inventory = Number(input.dataset.inventory || Infinity);
      const box = input.closest('.bundle-box');
      const plusBtn = box.querySelector('button[name="plus"]');

      plusBtn.disabled = this.isMaxQuantityReached() || Number(input.value) >= inventory;
    });
  }

  calculateTotalQuantity() {
    return [...this.boxesQuantityInput].reduce((acc, input) => acc + Number(input.value), 0);
  }

  calculateTotalPrice() {
    const { btn, price } = this.priceSelectors;
    const activeInputs = [...this.quantityBoxes]
      .filter((box) => box.classList.contains('bundle-box--active'))
      .map((box) => box.querySelector('input[data-price]'));

    const totalPrice = [...activeInputs].reduce(
      (acc, input) => acc + Number(input.getAttribute('data-price')) * Number(input.value),
      0
    );
    const shopifyFormat = themeVariables.settings.moneyFormatString;
    const shopifyFormatMoney = themeVariables.utils.money;
    const totalPriceMoney = shopifyFormatMoney(totalPrice, shopifyFormat);
    if (btn instanceof HTMLElement) {
      btn.toggleAttribute('hidden', totalPrice === 0);
      btn.textContent = `- ${totalPriceMoney}`;
    }
    if (price instanceof HTMLElement) {
      price.toggleAttribute('hidden', totalPrice === 0);
      price.textContent = `${totalPriceMoney}`;
    }
  }

  getInactiveBoxes() {
    return [...this.quantityBoxes].filter((box) => !box.classList.contains('bundle-box--active'));
  }

  isMaxQuantityReached() {
    return this.quantity >= this.maxQuantity;
  }

  attachProperties() {
    if (this.maxAmountPerItems === 'null') return;
    const amountPerItems = this.maxAmountPerItems.split(',');
    if (Array.isArray(amountPerItems)) {
      amountPerItems.forEach((amount, index) => {
        const currentFieldset = this.fieldsets[index];
        if (currentFieldset && currentFieldset instanceof HTMLDivElement) {
          currentFieldset.setAttribute('data-max-item', amount);
        }
      });

      this.setAttribute('data-amount-mode', 'true');
    }
  }

  shouldDisabledFieldset(currentBox) {
    const isAmountMode = this.dataset.amountMode === 'true';
    if (!isAmountMode || !currentBox) return;

    const currentFieldset = currentBox.closest('.cart-bundle__list');
    const errorNotification = currentFieldset.previousElementSibling;
    const maxItem = Number(currentFieldset.dataset.maxItem);

    const currentAmountInFieldset = [...currentFieldset.querySelectorAll('.bundle-box__quantity input')].reduce(
      (sum, input) => sum + Number(input.value || 0),
      0
    );

    const isDisabled = currentAmountInFieldset >= maxItem;
    currentFieldset.classList.toggle('cart-bundle__list--disabled', isDisabled);

    const typeNotification = maxItem === 1 ? 'single' : 'multi';
    const nameDataAttribute = `data-${typeNotification}-error`;
    const notificationText = errorNotification.getAttribute(nameDataAttribute);

    clearTimeout(errorNotification._hideTimer);
    clearTimeout(errorNotification._showTimer);

    if (isDisabled && notificationText) {
      const text = notificationText.replace('[]', maxItem);

      errorNotification.classList.add('visible');
      errorNotification.textContent = text;

      errorNotification._showTimer = setTimeout(() => {
        errorNotification.style.opacity = '1';
      }, 20);
    } else {
      errorNotification.style.opacity = '0';

      errorNotification._hideTimer = setTimeout(() => {
        errorNotification.textContent = '';
        errorNotification.classList.remove('visible');
      }, 300);
    }
  }

  init() {
    this.setAttribute('data-is-load', 'true');
  }
}

if (!customElements.get('cart-bundle')) {
  customElements.define('cart-bundle', CartBundle);
}
